[
  {
    "id": "TB-B7P-001",
    "module": "Taalbegrip",
    "difficulty": 202,
    "question": "Tik op het stuk tekst waar 'er' naar verwijst.",
    "options": ["Bij het skatepark"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "De gemeente wil een nieuw ", "id": "s1", "isTappable": false },
        { "text": "skatepark", "id": "s2", "isCorrect": true },
        { "text": " bouwen. ", "id": "s3", "isTappable": false },
        { "text": "Jongeren", "id": "s4" },
        { "text": " zijn enthousiast, maar ", "id": "s5", "isTappable": false },
        { "text": "omwonenden", "id": "s6" },
        { "text": " maken zich zorgen over geluidsoverlast. De wethouder belooft dat ", "id": "s7", "isTappable": false },
        { "text": "er", "id": "s8", "isHighlighted": true, "isTappable": false },
        { "text": " geluidswerende maatregelen komen.", "id": "s9", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "Goed! 'Er' verwijst naar de locatie van het skatepark. Daar komen geluidswerende maatregelen.",
        "s4": "De jongeren zijn niet de locatie waar maatregelen komen.",
        "s6": "De omwonenden zijn niet de locatie."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-SKATEPARK",
    "explanation": "'Er' verwijst naar de locatie van het skatepark. Daar komen geluidswerende maatregelen.",
    "distractorExplanations": {
      "3": "De jongeren zijn niet de locatie.",
      "5": "De omwonenden zijn niet de locatie."
    }
  },
  {
    "id": "TB-B7P-002",
    "module": "Taalbegrip",
    "difficulty": 202,
    "question": "Tik op het signaalwoord dat een tegenstelling aangeeft.",
    "options": ["Hoewel"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "Hoewel", "id": "s1", "isCorrect": true },
        { "text": " Nederland een klein land is, heeft het een enorme invloed op de voedselproductie. Het land exporteert ", "id": "s2", "isTappable": false },
        { "text": "jaarlijks", "id": "s3" },
        { "text": " voor miljarden euro's aan landbouwproducten. ", "id": "s4", "isTappable": false },
        { "text": "Dit", "id": "s5" },
        { "text": " komt ", "id": "s6", "isTappable": false },
        { "text": "onder andere", "id": "s7" },
        { "text": " door de innovatieve kassen en slimme landbouwtechnologie.", "id": "s8", "isTappable": false }
      ],
      "feedbackMap": {
        "s1": "Goed! 'Hoewel' geeft een tegenstelling aan: je verwacht niet dat een klein land zoveel exporteert.",
        "s3": "'Jaarlijks' geeft tijd aan, geen tegenstelling.",
        "s5": "'Dit' is een verwijswoord, geen signaalwoord voor tegenstelling.",
        "s7": "'Onder andere' geeft een opsomming aan, geen tegenstelling."
      }
    },
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-HOEWEL-NL",
    "explanation": "'Hoewel' geeft een tegenstelling aan: je verwacht niet dat een klein land zoveel exporteert.",
    "distractorExplanations": {
      "2": "'Jaarlijks' geeft tijd aan.",
      "4": "'Dit' is een verwijswoord.",
      "6": "'Onder andere' geeft een opsomming aan."
    }
  },
  {
    "id": "TB-B7P-003",
    "module": "Taalbegrip",
    "difficulty": 202,
    "question": "Lees de ingezonden brief:\n\n\"Geachte redactie, ik vind het belachelijk dat de bibliotheek op zondag dicht is. Veel werkende ouders hebben doordeweeks geen tijd. De bibliotheek zou juist op zondag open moeten zijn!\"\n\nWat voor soort tekst is dit?",
    "options": ["Een betogend/overtuigend stuk (de schrijver wil iets veranderen)", "Een informatief stuk (de schrijver geeft feiten)", "Een verhalend stuk (de schrijver vertelt een verhaal)", "Een instructie (de schrijver legt uit hoe iets moet)"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "tekstsoort",
    "familyId": "TB-TEKSTSOORT-BRIEF",
    "explanation": "De schrijver wil iets veranderen ('zou open moeten zijn') en gebruikt emotionele woorden ('belachelijk'). Dit is een betogend stuk.",
    "distractorExplanations": {
      "1": "Er worden meningen gegeven, niet alleen feiten.",
      "2": "Er wordt geen verhaal verteld.",
      "3": "Er wordt niet uitgelegd hoe iets moet."
    }
  },
  {
    "id": "TB-B7P-004",
    "module": "Taalbegrip",
    "difficulty": 202,
    "question": "Tik op het stuk tekst waar 'dit hart' naar verwijst.",
    "options": ["Het derde hart"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "Octopussen hebben drie harten en blauw bloed. ", "id": "s1", "isTappable": false },
        { "text": "Twee harten", "id": "s2" },
        { "text": " pompen bloed naar de kieuwen. ", "id": "s3", "isTappable": false },
        { "text": "Het derde hart", "id": "s4", "isCorrect": true },
        { "text": " pompt bloed door de rest van het lichaam. Als een octopus zwemt, stopt ", "id": "s5", "isTappable": false },
        { "text": "dit hart", "id": "s6", "isHighlighted": true, "isTappable": false },
        { "text": " tijdelijk.", "id": "s7", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "De twee harten bij de kieuwen worden eerder genoemd. 'Dit hart' verwijst naar het laatstgenoemde hart.",
        "s4": "Goed! 'Dit hart' verwijst naar het derde hart dat bloed door het lichaam pompt."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-OCTOPUS",
    "explanation": "'Dit hart' verwijst naar het laatstgenoemde hart: het derde hart dat bloed door het lichaam pompt.",
    "distractorExplanations": {
      "1": "De twee harten bij de kieuwen worden eerder genoemd."
    }
  },
  {
    "id": "TB-B7P-005",
    "module": "Taalbegrip",
    "difficulty": 202,
    "question": "Lees de tekst:\n\n\"Vroeger dachten mensen dat tomaten giftig waren. Pas in de 18e eeuw ontdekten Europeanen dat je ze veilig kon eten. Tegenwoordig is de tomaat een van de populairste groenten ter wereld.\"\n\nWelke signaalwoorden geven de tijdsvolgorde aan?",
    "options": ["Vroeger, Pas in de 18e eeuw, Tegenwoordig", "Dachten, ontdekten, is", "Giftig, veilig, populairste", "Mensen, Europeanen, wereld"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-TOMAAT",
    "explanation": "'Vroeger', 'Pas in de 18e eeuw' en 'Tegenwoordig' markeren drie momenten in de tijd.",
    "distractorExplanations": {
      "1": "Dit zijn werkwoorden, geen signaalwoorden voor tijd.",
      "2": "Dit zijn bijvoeglijke naamwoorden.",
      "3": "Dit zijn zelfstandige naamwoorden."
    }
  },
  {
    "id": "TB-B7P-006",
    "module": "Taalbegrip",
    "difficulty": 202,
    "question": "Wat betekent het woord 'innovatieve' in de zin: 'Dit komt door de innovatieve kassen.'",
    "options": ["Vernieuwend, met nieuwe technologie", "Heel grote", "Heel oude", "Heel dure"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-INNOVATIEF",
    "explanation": "'Innovatief' komt van 'innovatie' (vernieuwing). Het betekent dat er nieuwe, slimme technieken worden gebruikt.",
    "distractorExplanations": {
      "1": "Innovatief gaat niet over grootte.",
      "2": "Innovatief is juist het tegenovergestelde van oud.",
      "3": "Innovatief gaat niet over prijs."
    }
  },
  {
    "id": "TB-B7P-007",
    "module": "Taalbegrip",
    "difficulty": 202,
    "question": "Lees de tekst:\n\n\"Wetenschappers ontdekten dat kraaien gereedschap kunnen maken. Ze buigen takjes om insecten uit boomstammen te vissen. Bovendien onthouden ze welk gereedschap het beste werkt. Sommige onderzoekers noemen kraaien daarom 'de apen van de vogelwereld'.\"\n\nWaarom worden kraaien 'de apen van de vogelwereld' genoemd?",
    "options": ["Omdat ze net als apen slim zijn en gereedschap gebruiken", "Omdat ze op apen lijken", "Omdat ze in bomen leven", "Omdat ze insecten eten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-KRAAIEN-APEN",
    "explanation": "Apen staan bekend om hun intelligentie en gereedschapgebruik. Kraaien doen hetzelfde, vandaar de vergelijking.",
    "distractorExplanations": {
      "1": "De vergelijking gaat over intelligentie, niet uiterlijk.",
      "2": "Veel vogels leven in bomen, dat maakt ze niet bijzonder.",
      "3": "Insecten eten is niet de reden voor de vergelijking met apen."
    }
  },
  {
    "id": "TB-B7P-008",
    "module": "Taalbegrip",
    "difficulty": 202,
    "question": "Welk signaalwoord past het best?\n\n\"De school heeft nieuwe computers aangeschaft. ... werken ze nog steeds met oude software.\"",
    "options": ["Desondanks", "Daarom", "Bovendien", "Doordat"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-DESONDANKS-2",
    "explanation": "'Desondanks' past omdat er een tegenstelling is: nieuwe computers, maar oude software.",
    "distractorExplanations": {
      "1": "'Daarom' zou een logisch gevolg aangeven, maar oude software is geen logisch gevolg van nieuwe computers.",
      "2": "'Bovendien' voegt iets toe, maar hier is sprake van een tegenstelling.",
      "3": "'Doordat' geeft een oorzaak aan."
    }
  },
  {
    "id": "TB-B7P-009",
    "module": "Taalbegrip",
    "difficulty": 202,
    "question": "Tik op het stuk tekst waar 'daarin' naar verwijst.",
    "options": ["de top te bereiken"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "De Mount Everest is met 8.849 meter de hoogste berg ter wereld. Elk jaar proberen honderden ", "id": "s1", "isTappable": false },
        { "text": "klimmers", "id": "s2" },
        { "text": " ", "id": "s3", "isTappable": false },
        { "text": "de top te bereiken", "id": "s4", "isCorrect": true },
        { "text": ". Niet iedereen slaagt ", "id": "s5", "isTappable": false },
        { "text": "daarin", "id": "s6", "isHighlighted": true, "isTappable": false },
        { "text": ". De tocht is gevaarlijk door ", "id": "s7", "isTappable": false },
        { "text": "extreme kou", "id": "s8" },
        { "text": ", lawines en zuurstofgebrek.", "id": "s9", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "Klimmers is wie het probeert, niet waar 'daarin' naar verwijst.",
        "s4": "Goed! 'Daarin' verwijst naar 'de top bereiken'. Niet iedereen slaagt erin.",
        "s8": "Extreme kou is een gevaar, niet waar 'daarin' naar verwijst."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-EVEREST",
    "explanation": "'Daarin' verwijst naar 'de top bereiken' uit de vorige zin. Niet iedereen slaagt erin de top te bereiken.",
    "distractorExplanations": {
      "1": "Klimmers is wie het probeert, niet waar 'daarin' naar verwijst.",
      "7": "Extreme kou is een gevaar, niet waar 'daarin' naar verwijst."
    }
  },
  {
    "id": "TB-B7P-010",
    "module": "Taalbegrip",
    "difficulty": 202,
    "question": "Wat betekent het woord 'objectief' in de zin: 'Een journalist moet objectief schrijven.'",
    "options": ["Gebaseerd op feiten, zonder eigen mening", "Met veel details", "Heel snel", "Met mooie woorden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-OBJECTIEF",
    "explanation": "'Objectief' betekent feitelijk, zonder je eigen mening erin te verwerken. Het tegenovergestelde is 'subjectief'.",
    "distractorExplanations": {
      "1": "Objectief gaat niet over hoeveelheid details.",
      "2": "Objectief gaat niet over snelheid.",
      "3": "Objectief gaat niet over schrijfstijl."
    }
  }
]